import { api } from '@/lib/axios';
import type { Page } from '@/services/chantiers';

export type TiersType = 'CLIENT' | 'FOURNISSEUR' | 'SOUS_TRAITANT' | 'LES_TROIS';

export interface WilayaDTO {
  id: number;
  code: string;
  nom_fr: string;
  nom_ar: string;
}

export interface TiersDTO {
  id: string;
  code: string;
  type: TiersType;
  raison_sociale: string;
  nif: string | null;
  nis: string | null;
  rc: string | null;
  ai: string | null;
  specialite: string | null;
  delai_livraison_jours: number | null;
  adresse: string | null;
  wilaya_id: number | null;
  telephone: string | null;
  email: string | null;
  rib_banque: string | null;
  rib_agence: string | null;
  rib_compte: string | null;
  rib_cle: string | null;
  contact_nom: string | null;
  contact_telephone: string | null;
  notes: string | null;
  is_active: boolean;
  is_archived: boolean;
  /** Nombre de dépenses rattachées à ce tiers (aperçu rapide). */
  nb_depenses: number;
}

export interface TiersInput {
  code: string;
  type: TiersType;
  raison_sociale: string;
  nif?: string | null;
  nis?: string | null;
  rc?: string | null;
  ai?: string | null;
  specialite?: string | null;
  delai_livraison_jours?: number | null;
  adresse?: string | null;
  wilaya_id?: number | null;
  telephone?: string | null;
  email?: string | null;
  rib_banque?: string | null;
  rib_agence?: string | null;
  rib_compte?: string | null;
  rib_cle?: string | null;
  contact_nom?: string | null;
  contact_telephone?: string | null;
  notes?: string | null;
  is_active?: boolean;
  is_archived?: boolean;
}

export const TIERS_TYPES: TiersType[] = ['CLIENT', 'FOURNISSEUR', 'SOUS_TRAITANT', 'LES_TROIS'];
export const TIERS_TYPE_LABEL: Record<TiersType, string> = {
  CLIENT: 'Client',
  FOURNISSEUR: 'Fournisseur',
  SOUS_TRAITANT: 'Sous-traitant',
  LES_TROIS: 'Client / Fournisseur / ST',
};

export async function listTiers(params?: { q?: string; type?: TiersType; archives?: boolean; page?: number; size?: number }): Promise<Page<TiersDTO>> {
  const { data } = await api.get<Page<TiersDTO>>('/tiers', { params });
  return data;
}

export async function getTier(id: string): Promise<TiersDTO> {
  const { data } = await api.get<TiersDTO>(`/tiers/${id}`);
  return data;
}

export async function createTiers(payload: TiersInput): Promise<TiersDTO> {
  const { data } = await api.post<TiersDTO>('/tiers', payload);
  return data;
}

export async function updateTiers(id: string, payload: Partial<TiersInput>): Promise<TiersDTO> {
  const { data } = await api.put<TiersDTO>(`/tiers/${id}`, payload);
  return data;
}

export async function deleteTiers(id: string): Promise<void> {
  await api.delete(`/tiers/${id}`);
}

/** Liste des 58 wilayas (table de référence). Mise en cache via React Query. */
export async function listWilayas(): Promise<WilayaDTO[]> {
  const { data } = await api.get<WilayaDTO[]>('/wilayas');
  return data;
}
